'use client';

import { RouterLink } from '@/navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, AlertTitle, Button, Container, Stack, Typography } from '@mui/material';
import { icons } from '@peerless/ui-assets/icons';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

/**
 * Error component renders when there is an error rendering any page.
 */
export default function PageError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations('Error');

  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <Container>
      <Alert severity="error" sx={{ my: '30vh' }} id="error">
        <AlertTitle>{t('error-title')}</AlertTitle>
        <Typography>{t('troubleshooting-list-heading')}</Typography>
        <ul>
          <Typography component="li">{t('troubleshooting-list-item-1')}</Typography>
          <Typography component="li">{t('troubleshooting-list-item-2')}</Typography>
          <Typography component="li">{t('troubleshooting-list-item-3')}</Typography>
        </ul>

        <Typography>{t('troubleshooting-contact-support')}</Typography>

        <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
          <Button variant="text" color="primary" onClick={reset}>
            <FontAwesomeIcon fixedWidth icon={icons.refresh} />
            &nbsp;{t('retry-request')}
          </Button>
          <Button variant="text" color="secondary" component={RouterLink} href="/">
            <FontAwesomeIcon fixedWidth icon={icons.home} />
            &nbsp;{t('navigate-home')}
          </Button>
        </Stack>
      </Alert>
    </Container>
  );
}
